import { withDefault } from '@weft/utils';
import { DEFAULT_REPORT_TYPE,
  useReportTypeStateParam } from '../pages/reports/reports-page/reports-page-hooks/report-type-state-param-hook';

export const useTabSelection = () => {
  const [currentReportType, setCurrentReportType] = useReportTypeStateParam();

  const activeTabType = withDefault(currentReportType, DEFAULT_REPORT_TYPE);

  return { activeTabType, handleTabSelection: setCurrentReportType };
};